import { get } from 'vuex-pathify';

export default {
  computed: {
    identifiedFeatures: get('map/identifiedFeatures'),
    streetLampsLayerId: get('admin/modulesMapping@zdm_data.layers.street_lamp'),
    hasAnyFeatures() {
      return this.identifiedFeatures.length > 0;
    },
  },
  methods: {
    onHover(item, value) {
      const { layerId, id } = item;
      if (value) {
        this.$store.set('map/ADD_SELECTED_FEATURES!', {
          type: 'highlitedFeatures',
          features: {
            [layerId]: [id],
          },
        });
      } else {
        this.$store.set('map/DELETE_SELECTED_FEATURES!', {
          type: 'highlitedFeatures',
          features: {
            [layerId]: [id],
          },
        });
      }
    },
    showCard(id, layerId, feature) {
      if (feature.parentFeatureId) {
        this.$router.push({
          name: 'layerFeature',
          params: {
            lid: layerId,
            fid: id,
          },
          query: {
            lamp_id: feature.parentFeatureId,
            id: id,
            type: feature.dataSource.match(/(?<=zdm_data_).*/)[0],
          },
        });
      } else {
        this.$router.push({
          name: 'layerFeature',
          params: { lid: layerId, fid: id },
        });
      }
    },
    zoomToFeature(id, layerId) {
      this.$root.$emit('zoomToFeature', layerId, 'layers', id);
    },
  },
};
